<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import _log from '@/helpers/log';

@Component
export default class LogsMixin extends Vue {

  public logError(error: any) {
    _log.logError(error);
  }

  public logTime(loggedFunc: () => any): any {
    return _log.logTime(loggedFunc);
  }

}
</script>
